import { Link, useLocation } from "wouter";

const items: { href: string; label: string }[] = [
  { href: "/", label: "Fleet" },
  { href: "/shops", label: "Shops" },
  { href: "/uptime", label: "Uptime" },
  { href: "/rentals/active", label: "Active rentals" },
  { href: "/batteries/faulty", label: "Faulty batteries" },
  { href: "/docs", label: "Docs" },
];

export function Nav() {
  const [location] = useLocation();
  return (
    <nav className="sticky top-0 z-20 border-b border-zinc-800/80 bg-zinc-950/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <Link href="/" className="flex items-center gap-2.5">
          <span className="relative flex h-7 w-7 items-center justify-center rounded-md bg-brand-gradient text-[13px] font-black text-white shadow-[0_4px_14px_-4px_rgba(168,85,247,0.6)]">
            B
          </span>
          <div className="leading-tight">
            <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500">Boosted</div>
            <div className="text-sm font-semibold brand-text">Kiosk Ops</div>
          </div>
        </Link>
        <div className="flex items-center gap-1">
          {items.map((it) => {
            const active =
              it.href === "/" ? location === "/" : location.startsWith(it.href);
            return (
              <Link
                key={it.href}
                href={it.href}
                className={
                  "rounded-md px-3 py-1.5 text-xs font-medium transition " +
                  (active
                    ? "bg-brand-purple/15 text-purple-100 ring-1 ring-brand-purple/40"
                    : "text-zinc-400 hover:bg-zinc-900 hover:text-zinc-200")
                }
              >
                {it.label}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
